import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-pin-keypad',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pin-keypad.component.html',
  styleUrls: ['./pin-keypad.component.css']
})
export class PinKeypadComponent {
  @Input() pinValue: string = '';
  @Output() pinValueChange = new EventEmitter<string>();

  pinDisplay: string = '';
  keys: (number | string)[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, '*', 0, '<'];

  ngOnChanges() {
    this.updateDisplay();
  }

  onKeyPressed(key: number | string) {
    if (key === '<') {
      this.pinValue = this.pinValue.slice(0, -1);
    } else if (this.pinValue.length < 4 && key !== '*') {
      this.pinValue += key.toString();
    }
    this.updateDisplay();
    this.pinValueChange.emit(this.pinValue);
  }

  updateDisplay() {
    this.pinDisplay = '*'.repeat(this.pinValue.length);
  }
} 